<main class="main-container">
    <div class="heading">
        Get In Touch
    </div>
    <div class="underline"></div>
    <div class="text">
        For property related queries, to view a property or to make an offer, please contact the Broker/Agent directly.
    </div>
    <div class="text">
        For general queries, email: <a href="mailto:queries@propertymatrix.co.za"
            class="email-address">queries@propertymatrix.co.za</a>
    </div>
</main>